<template>
  <div class="success gray bold">
    支付失败!
    <div class="icon-success iconfont">&#xe64b;</div>
    <div
      class="btn-back"
      @click="$router.push({
        path: '/Personal/Setting',
      })"
    >返回</div>
  </div>
</template>

<script>
export default {
  name: 'Fail'
}
</script>

<style lang="scss" scoped>
.success {
  font-size: 24px;
  padding-top: 180px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .icon-success {
    margin: 30px 0 150px;
    font-size: 70px;
    color: #ed4114;
  }

  .btn-back {
    font-size: 18px;
    text-align: center;
    color: #fff;
    border-radius: 5px;
    background: linear-gradient(to right, #f2a612, #f7c827);
    width: 278px;
    height: 40px;
    line-height: 40px;
    font-weight: bold;
    letter-spacing: 5px;
    text-indent: 5px;
  }
}
</style>
